import SearchAlbumResult from './SearchAlbumResult'

export default SearchAlbumResult